import { TYPE_COLLECTION } from './input-types';

export const id = 'marketplaceNotification';
export const apiKey = 'MarketplaceNotified';
export const type = TYPE_COLLECTION;

export const marketplaceNotification = {
  id,
  apiKey,
  type,
};
